module.exports = __webpack_public_path__ + "img/support.60df9c8.jpg";